import { z } from "zod";

const assignedMaterialSchema = z.object({
	id: z.string(),
	alias: z.string().nullish(),
});

export const trackSchema = z
	.object({
		trackNumber: z.number().optional(),
		assignedMaterial: assignedMaterialSchema.optional(),
		loadedCorrugate: assignedMaterialSchema.nullish(),
	})
	.passthrough();

export const trackWithOffsetSchema = trackSchema.merge(
	z.object({
		trackNumber: z.number(),
		trackOffset: z.number().catch(0),
	}),
);

export type Track = z.infer<typeof trackSchema>;
export type TrackWithOffset = z.infer<typeof trackWithOffsetSchema>;

export type AssignedMaterial = z.infer<typeof assignedMaterialSchema>;
